import { useState, useEffect, useCallback } from 'react';
import { getSIESConfig } from '../api/requests/siesConfig';

export const useSIESConfig = () => {
  const [siesEnabled, setSIESEnabled] = useState<boolean>(false);
  const [mounted, setMounted] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>();

  const fetchConfig = useCallback(async () => {
    if (loading) {
      return;
    }
    setError(undefined);
    setLoading(true);
    const { data, error } = await getSIESConfig();
    setSIESEnabled(!!data?.enabled);
    setError(error ? 'FETCH_ERROR' : undefined);
    setLoading(false);
  }, [loading]);

  useEffect(() => {
    if (!mounted) {
      fetchConfig();
      setMounted(true);
    }
  }, [mounted, fetchConfig]);

  return {
    siesEnabled,
    error,
    loading,
    mounted,
  };
};
